import { useMutation as defaultUseMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
export const setAutoUpgradeMutation = gql `
  mutation upsells_setAutoUpgradeMutation($input: AutoTaskTierUpdateInput!) {
    setAutoUpgrade(input: $input) {
      id
      accountId
      featureName
      isEnrolled
    }
  }
`;
export const useAutoUpgradeFeatureEnrollment = ({ accountId, featureEnrollmentList, useMutation, onSetAutoUpgradeFailure, onSetAutoUpgradeSuccess, upgradePlanId, }) => {
    const _useMutation = useMutation || defaultUseMutation;
    const autoUpgradeFeature = featureEnrollmentList === null || featureEnrollmentList === void 0 ? void 0 : featureEnrollmentList.find((feature) => (feature === null || feature === void 0 ? void 0 : feature.featureName) === "AUTO_UPGRADE");
    const [_setAutoUpgrade, { error: mutationError, loading: isLoadingMutation },] = _useMutation(setAutoUpgradeMutation, {
        onCompleted: onSetAutoUpgradeSuccess,
        onError: onSetAutoUpgradeFailure,
    });
    const setAutoUpgrade = (isEnrolled) => {
        _setAutoUpgrade({
            variables: {
                input: {
                    accountId,
                    id: autoUpgradeFeature === null || autoUpgradeFeature === void 0 ? void 0 : autoUpgradeFeature.id,
                    isEnrolled,
                    upgradePlanId,
                },
            },
        });
    };
    const isAutoUpgradeEnabled = Boolean(autoUpgradeFeature === null || autoUpgradeFeature === void 0 ? void 0 : autoUpgradeFeature.isEnrolled);
    return {
        error: mutationError === null || mutationError === void 0 ? void 0 : mutationError.message,
        isAutoUpgradeEnabled,
        isEligibleForAutoUpgrade: !!autoUpgradeFeature && !isAutoUpgradeEnabled,
        isLoading: isLoadingMutation,
        setAutoUpgrade,
    };
};

// @zapier/upsells@8.0.1 (466b4077f)
